<template>
    <div>
        <HeaderBar/>
        <div class="d-flex flex-column bg-white">
            <div class="reportTitle mt-5 ml-1 mb-4">Inventario de ganado</div>
            
            <b-card header-border-variant="Primary" class="shadow  px-0 mx-2" no-body>
                <b-row no-gutters>
                  <vue-good-table :columns="columns" :rows="rows"  styleClass="vgt-table bordered"
                        :search-options="{
                          enabled: false,
                        }" 
                        
                      >
                        <template slot="table-row" slot-scope="props">
                          <!-- Column: Status -->
                          <span v-if="props.column.field === 'age'">
                            <span width="200px">
                              {{ props.row.age }}
                            </span>
                          </span>

                          <!-- Column: Common -->
                          <span v-else>
                            {{ props.formattedRow[props.column.field] }}
                          </span>
                        </template>

                      </vue-good-table>
                </b-row>
            </b-card>
            <ControlMenu />
        </div>
    </div>
</template>


<script>
import { BCard, BRow, BCardBody, BCardText, BButton, BLink } from 'bootstrap-vue'
import ControlMenu from '@/components/ControlMenu.vue'
import HeaderBar from '@/components/HeaderBar.vue'
import Ripple from 'vue-ripple-directive'
import { VueGoodTable } from 'vue-good-table'

export default {
    components: {
        BCard,
        BButton,
        BCardBody,
        BCardText,
        BRow,
        BLink,
        ControlMenu,
        HeaderBar,
        VueGoodTable,

    },
    directives: {
    Ripple,
  },
  data(){
    return{
      pageLength: 25,
      dir: false,
      status1: null,
      status2: null,
      modalShow: false,
      modalCase: 0,
      editShow:false,
      modalTrashShow:false,
      columns: [
        {
          label:  'EDADES',
          field:  'age',
          type:   'string',
          width:'200px'
        },  
        {
          label:  'AÑO 1',
          field:  'qty1',
          type:   'string',
          width:'80px'
        },
        {
          label:  'AÑO 2',
          field:  'qty2',
          type:   'string',
          width:'80px'
        }

      ],
      rows: [],
      animalData:[],
      animal:{
        weight:0,
        age:0,
      },
    }
  },
  methods:{
    async fetchAnimals(config){
      let self=this;
      let farmId= localStorage.getItem('currentFarm');
      fetch(this.$apiUrl+"list/animals?farm_id="+farmId+"&state=1", config)
        .then(response => response.json())
        .then(result => {
            console.log(result.animals);
            let mMinOneYear=0;
            let mMaxOneYear=0;
            let mMaxTwoYear=0;
            let mTotal=0;
            let fMinOneYear=0;
            let fMaxOneYear=0;
            let fMaxTwoYear=0;
            let fTotal=0;
            result.animals.map(function (currAnimal){
              if(currAnimal.sex==0){
                mTotal++;
                if(currAnimal.age<1){
                  mMinOneYear++;
                }else if(currAnimal.age>=1||currAnimal.age<3){
                  mMaxOneYear++;
                }else if(currAnimal.age>=3){
                  mMaxTwoYear++;
                }
              }else{
                fTotal++;
                if(currAnimal.age<1){
                  fMinOneYear++;
                }else if(currAnimal.age>=1||currAnimal.age<3){
                  fMaxOneYear++;
                }else if(currAnimal.age>=3){
                  fMaxTwoYear++;
                }
              }
              

            })
            self.rows.push({age:'Hembras',qty1:0,qty2:0})
            self.rows.push({age:'Menos de 1 Año',qty1:fMinOneYear,qty2:0})
            self.rows.push({age:'1 a 2 Años',qty1:fMaxOneYear,qty2:0})
            self.rows.push({age:'Mas de 2 Años',qty1:fMaxTwoYear,qty2:0})
            self.rows.push({age:'Machos',qty1:0,qty2:0})
            self.rows.push({age:'Menos de 1 Año',qty1:mMinOneYear,qty2:0})
            self.rows.push({age:'1 a 2 Años',qty1:mMaxOneYear,qty2:0})
            self.rows.push({age:'Mas de 2 Años',qty1:mMaxTwoYear,qty2:0})
            self.rows.push({age:'Total Hembras',qty1:fTotal,qty2:0})
            self.rows.push({age:'Total Machos',qty1:mTotal,qty2:0})
            self.rows.push({age:'Total General',qty1:(mTotal+fTotal),qty2:0})
            //this.rows = result.animals.map(item => {return {id:item.id,number:item.number,name:item.name,sex:item.sex,weight:item.weight, age:item.age}});
            console.log(this.animals);
        })
    },

  },
  created() {
    const token = localStorage.getItem("accessToken");
    const config = {headers: {"X-Authorization": `Bearer ${token}`}};
    this.fetchAnimals(config);
  },
}
</script>

<style>
.reportTitle {
    font-weight: 600;
    font-size: 24px;
}
.indicaterEco {
    font-weight: 500;
    font-size: 18px;
}
</style>